module.exports = __webpack_public_path__ + "img/portrait-012.e5ccb6b9.jpg";